import { assert_record_value } from '@shared/asserts/utils_asserts';
import { ENUM__grid2d_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__grid2d_feature';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';

const E = ENUM__grid2d_feature;

export function FN_GRID2D__possible_features__workspace_users(type: string): string[] {
  let out: string[] = [];

  let map: any = new Object();

  map[ENUM__workspace_entity.ENTITY_GENERATION] = [];

  map[ENUM__workspace_entity.ENTITY_SEARCH] = [E.CELLS__SORT];

  map[ENUM__workspace_entity.ENTITY_USER_TASK] = [E.CELLS__SORT];

  map[ENUM__workspace_entity.COLLECTION_CUSTOM] = [E.CELLS__SORT, E.IMAGE_INTERNAL__ADD, E.IMAGE_INTERNAL__DELETE, E.IMAGE_EXTERNAL__ADD];

  map[ENUM__workspace_entity.COLLECTION_UPLOADS] = [E.CELLS__SORT, E.IMAGE_EXTERNAL__ADD];

  map[ENUM__workspace_entity.COLLECTION_VIEWED_ON_SEARCH] = [E.CELLS__SORT];
  map[ENUM__workspace_entity.COLLECTION_GENERATED] = [E.CELLS__SORT];

  map[ENUM__workspace_entity.COLLECTION_FAVORITES] = [E.CELLS__SORT, E.IMAGE_INTERNAL__ADD, E.IMAGE_INTERNAL__DELETE, E.IMAGE_EXTERNAL__ADD];

  out = assert_record_value(map, type);

  return [...out];
}
